import React from 'react';
import { Banknote } from 'lucide-react';
import { ewallets, qrisPayment } from '../mock';

const PaymentLogo = ({ p }) => (
  <div className="h-16 sm:h-20 w-full rounded-xl bg-white border border-[color:var(--brand-50)] flex items-center justify-center p-3 hover:border-[color:var(--brand)] hover:shadow-md hover:-translate-y-1 transition-all duration-300">
    {p.icon === 'banknote' ? (
      <div className="flex items-center gap-2">
        <Banknote className="w-8 h-8 text-[color:var(--brand)]" />
        <span className="font-bold text-[color:var(--ink)] text-sm sm:text-base">{p.name}</span>
      </div>
    ) : (
      <img
        src={p.logo}
        alt={p.name}
        className="max-h-9 sm:max-h-10 max-w-full object-contain"
        loading="lazy"
        onError={(e) => {
          const span = document.createElement('span');
          span.className = 'font-bold text-[color:var(--ink)] text-sm';
          span.textContent = p.name;
          e.target.replaceWith(span);
        }}
      />
    )}
  </div>
);

const Payment = () => {
  return (
    <section className="py-16 lg:py-20 section-soft">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-white text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3 border border-[color:var(--brand-50)]">Pembayaran</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)]">
            Bayar Laundry, semudah ngomong <span className="text-[color:var(--brand)]">“Trust Me”</span>
          </h2>
        </div>

        {/* Row 1: E-Wallet & Tunai - centered */}
        <div className="reveal mb-10">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-8 w-8 rounded-full bg-[color:var(--brand)] text-white flex items-center justify-center font-bold text-sm">1</div>
            <h3 className="font-display text-lg sm:text-xl font-bold text-[color:var(--ink)]">E-Wallet & Tunai</h3>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 max-w-3xl mx-auto">
            {ewallets.map((p) => <PaymentLogo key={p.name} p={p} />)}
          </div>
        </div>

        {/* Row 2: QRIS - centered */}
        <div className="reveal">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="h-8 w-8 rounded-full bg-[color:var(--brand)] text-white flex items-center justify-center font-bold text-sm">2</div>
            <h3 className="font-display text-lg sm:text-xl font-bold text-[color:var(--ink)]">QRIS — Scan & Bayar</h3>
          </div>
          <div className="flex justify-center">
            <div className="w-full max-w-xs sm:max-w-sm">
              {qrisPayment.map((p) => <PaymentLogo key={p.name} p={p} />)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Payment;
